const ACTIVE_CLASS_NAME = 'active';

class InteractiveMap {
  constructor(container) {
    this.container = container;
    this.regions = container.querySelectorAll('#poland-map .region');
    this.infoContainer = container.querySelector('.ContactAdvisers__contact-info');

    this.showFirstAdvisersOnInit();
    this.handleRegionSelection();
  }

  showFirstAdvisersOnInit() {
    const firstRegion = this.regions[0];
    const adviserIds = firstRegion.dataset.advisers.split(',');
    const advisers = adviserIds.map(advisorId => advisersData[advisorId]);
    firstRegion.classList.add(ACTIVE_CLASS_NAME);
    this.buildInfoBox(advisers);
  }

  handleRegionSelection() {
    this.regions.forEach((region) => {
      region.addEventListener('click', () => {
        const adviserIds = region.dataset.advisers ? region.dataset.advisers.split(',') : [];
        const advisers = adviserIds.map(advisorId => advisersData[advisorId]);
        this.regions.forEach((el) => el.classList.remove(ACTIVE_CLASS_NAME));
        region.classList.add(ACTIVE_CLASS_NAME);
        this.buildInfoBox(advisers);
      });
    });
  }
  

  buildInfoBox(advisers) {
    this.infoContainer.innerHTML = '';
    
    if(advisers.length > 1) {
      this.infoContainer.classList.add('addFlex');
    }
  
    advisers.forEach((advisor) => {
      const container = document.createElement('div');
      container.classList.add('ContactAdvisers__person');

      let name = '';

      const regions = {
          Warszawa: 'Janser Mazowsze',
          Kraków: 'Janser Małopolska',
          'Lipno k. Leszna': 'Janser Polska',
      };

      if (advisor.type === 'adviser') {
        name = advisor.fullname;
    } else {
        name = regions[advisor.region];
    }

  
      container.innerHTML = `
        <figure><img src="${advisor.picture}" alt="${advisor.fullname}"></figure>
        <h3>${name}</h3>
        <p class="location">${advisor.region}</p>
        <a href="tel:${advisor.phone}" class="phone">(+48) ${advisor.phone}</a>
        <a href="mailto:${advisor.email}" class="email">${advisor.email}</a>
        <figure><img src="${advisor.qr_code}" alt="QR ${advisor.fullname}"></figure>
      `;
  
      this.infoContainer.appendChild(container);
    });
  }
}

window.addEventListener('load', () => {
  const mapContainer = document.querySelector('.ContactAdvisers');

  if (mapContainer) {
    new InteractiveMap(mapContainer);
  }
});
